// ============================================================================
// UTILITY - categoryConfig.js
// ============================================================================
// client/src/utilities/categoryConfig.js

import { CourseDomains } from '../types/courseDomains';


export const CATEGORY_CONFIGS = [
  ...new Map(
    Object.values(CourseDomains)
      .flatMap(domain => domain.canvases)
      .flatMap(canvas => canvas.categories)
      .map(cat => [cat.key, {
        key: cat.key,
        name: cat.label.replace(/^[\p{Emoji}\s]+/u, '').trim(),
        icon: cat.label.match(/^[\p{Emoji}]+/u)?.[0] || '📦',
        description: '',
        defaultExpanded: false
      }])
  ).values()
];

/**
 * Get category config by key
 */
export const getCategoryConfig = (key) => {
  return CATEGORY_CONFIGS.find(cat => cat.key === key);
};

export const getHardwareCategories = () => {
  const hardwareKeys = new Set(
    Object.values(CourseDomains)
      .flatMap(domain => domain.canvases)
      .filter(canvas => canvas.key === 'hardware')
      .flatMap(canvas => canvas.categories)
      .map(cat => cat.key)
  );

  return CATEGORY_CONFIGS.filter(cat => hardwareKeys.has(cat.key));
};

/**
 * Get all cloud categories
 */
export const getCloudCategories = () => {
  return CATEGORY_CONFIGS.filter(cat => 
    cat.key.startsWith('azure_')
  );
};


const hardwareKeys = new Set(
  Object.values(CourseDomains)
    .flatMap(domain => domain.canvases)
    .filter(canvas => canvas.key === 'hardware')
    .flatMap(canvas => canvas.categories)
    .map(cat => cat.key)
);

export const isHardwareCategory = (key) => hardwareKeys.has(key);
/**
 * Check if category is cloud
 */
export const isCloudCategory = (key) => {
  return key.startsWith('azure_');
};

/**
 * Get initial expanded state for all categories
 */
export const getInitialExpandedState = () => {
  const state = {};
  CATEGORY_CONFIGS.forEach(cat => {
    state[cat.key] = cat.defaultExpanded;
  });
  return state;
};

/**
 * Get category dropdown options for forms
 */
export const getCategoryDropdownOptions = () => {
  return CATEGORY_CONFIGS.map(cat => ({
    value: cat.key,
    label: `${cat.icon} ${cat.name}`,
    description: cat.description
  }));
};

export default CATEGORY_CONFIGS;